import TableRenderClass from '@C/tableRender/tableRenderClass';
import { invoice } from '@/api/ajax';
import { moneyFixed } from '@/tools/money';
import createExtend from '@C/createExtend';
import baseImgPreview from '@C/Base/baseImgPreview';
// 开票状态
const INVOICE_STATUS = new Map([
  [0, '待开票'],
  [1, '待确认'],
  [2, '已开票'],
  [3, '无法开票'],
  [4, '平台确认未通过']
]);
// 发票类别
// const INVOICE_CATEGORY = new Map([
//   [1, '增值税普通发票'],
//   [2, '增值税专用发票']
// ]);

let temporaryMap = new Map();
const fields = {
  index: {
    label: '序号',
    type: 'index',
    width: '50px'
  },
  customCheck: {
    type: 'customCheck',
    width: '50px',
    renderHeader: (h, tableData) => {
      let isAllCheck = Array.isArray(tableData) && tableData.length > 0;
      let isIndeterminate = false;
      tableData.forEach(item => {
        if (item['checkThis']) {
          isIndeterminate = true;
        } else {
          isAllCheck = false;
        }
      });
      // 在表格header中创建全选框
      return h(
        'el-checkbox',
        {
          props: {
            value: isAllCheck, // 全选/取消全选
            indeterminate: isAllCheck ? false : isIndeterminate // 是否部分选择
          },
          nativeOn: {
            click: e => {
              e.preventDefault();
              tableData.map((item, index) => {
                temporaryMap[isAllCheck ? 'delete' : 'set'](item.peopleId, {
                  ...item,
                  _index: index
                });
                item['checkThis'] = !isAllCheck;
              });
            } // 点击事件
          }
        },
        [h('span')]
      );
    },
    render: function(h, ctx, row, column, index, no) {
      return (
        <el-checkbox
          key={row.peopleId}
          value={row.checkThis}
          onChange={v => {
            temporaryMap[!v ? 'delete' : 'set'](row.peopleId, {
              ...row,
              _index: no
            });
            row.checkThis = v;
          }}
        >
          <span></span>
        </el-checkbox>
      );
    }
  },
  fullName: {
    label: '项目参与人', //"用户名",
    prop: 'fullName'
  },
  expand: {
    label: '',
    width: '150px',
    type: 'expand',
    render: (h, ctx, row) => {
      const { responseInvoiceImgList: imgList } = row;

      return h(
        'div',
        {
          style: {
            width: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexWrap: 'wrap'
            // padding:'16px'
          }
        },
        [
          imgList.length
            ? imgList.map(i => {
                return h(
                  'div',
                  {
                    class: 'mb16',
                    style: {
                      display: 'flex',
                      flexDirection: 'column',
                      // alignItems:'center',
                      margin: '8px',
                      background: '#e6f1fc',
                      boxShadow: '2px 4px 6px #bfbfbf'
                    }
                  },
                  [
                    h('img', {
                      domProps: { src: i.invoicePic },
                      style: {
                        width: '174px',
                        height: '112px',
                        cursor: 'zoom-in'
                      },
                      on: {
                        click: () => {
                          createExtend(baseImgPreview, {
                            src: i.invoicePic,
                            id: i.invoiceNo
                          });
                        }
                      }
                    }),
                    h(
                      'p',
                      {
                        style: {
                          padding: '0 8px'
                        }
                      },
                      ['编号：', i.invoiceNo]
                    )
                  ]
                );
              })
            : '没有上传任何发票。。。'
        ]
      );
    }
  },
  userPhone: {
    label: '手机号', //"用户手机号",
    prop: 'userPhone'
  },
  projectPriceTotal: {
    label: '开票金额', //"总金额  long类型 ",
    prop: 'invoicePrice',
    formatter: (r, c, v) => moneyFixed(+v)
  },
  invoiceCategory: {
    label: '发票类别', //"一级类目 int类型   1 增值税普通发票 2增值税专用发票 ",
    prop: 'invoiceTypeName'
    // formatter: (r, c, v) => INVOICE_CATEGORY.get(+v)
  },
  itemName: {
    label: '发票类目', //"二级类目名字",
    prop: 'itemName'
  },
  openStatus: {
    label: '开票状态',
    prop: 'invoiceStatus',
    // formatter: (r, c, v) => INVOICE_STATUS.get(+v),
    render: (h, ctx, row) => {
      const v = +row.invoiceStatus;
      const { noInvoiceReason } = row;
      const notOpen = v === 3;
      // if(notOpen){
      return h(
        'el-button',
        {
          props: {
            disabled: !notOpen,
            type: 'text'
          },
          on: {
            click: () => {
              ctx.parent.$msgbox({
                title: '驳回原因',
                message: noInvoiceReason
              });
            }
          }
        },
        INVOICE_STATUS.get(v)
      );
      // }
    }
  }
};

//初始化
export let example = new TableRenderClass({ fields });

export const detail = () => {
  temporaryMap = new Map();
  let isloading = false;
  return [
    {
      name: '申请委托|开票内容|详情|列表',
      childMenu: [
        example.createPart({
          name: '申请委托|开票内容|详情|列表',
          search: [
            {
              id: 'fullName',
              name: '项目参与人',
              tip: '请输入姓名',
              key: 'fullName',
              slot: 'input'
            },
            {
              id: 'phone',
              name: '手机号',
              tip: '请输入手机号',
              key: 'phone',
              slot: 'input'
            }
          ],
          list: query => {
            return new Promise(resolve => {
              invoice.detailOfCommission(query).then(res => {
                try {
                  res.data.data.list.map(item => {
                    item['checkThis'] = temporaryMap.has(item.peopleId);
                  });
                } catch (error) {}
                resolve(res);
              });
            });
          },
          requestNow: true,
          defaultQuery: {},
          beforeSearch: () => {
            temporaryMap = new Map();
          },
          moreBtnArr: [
            {
              name: '导出自然人发票',
              fn: (app, table) => {
                if (isloading) {
                  return;
                }
                if (temporaryMap.size == 0) {
                  table.$message.error('至少选择一个自然人');
                  return;
                }
                const msg = table.$message({
                  duration: 0,
                  message: '导出中...'
                });
                isloading = true;
                const peopleIds = [];
                temporaryMap.forEach((_, peopleId) => {
                  peopleIds.push(peopleId);
                });
                invoice
                  .downloadDetailsOnTheInvoice({
                    ids: peopleIds.join(',')
                  })
                  .then(res => {
                    msg.close();
                    isloading = false;
                    window.open(res.data.data, '_blank');
                  })
                  .catch(() => {
                    msg.close();
                    isloading = false;
                  });
              }
            }
          ],
          fields: [
            'customCheck',
            'expand',
            'index',
            'fullName',
            'userPhone',
            'projectPriceTotal',
            'invoiceCategory',
            'itemName',
            'invoiceItemId',
            'openStatus'
          ]
        })
      ]
    }
  ];
};
